import {
  AddPriceInput,
  MasterDataViewModel,
  PriceListViewModel,
  PriceValueInput,
  QuotationType
} from '@/api/api';
import {
  BAvatar,
  BPagination,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BRow,
  BCol,
  BDropdown,
  BDropdownItem,
  BCard,
  BCardHeader,
  BCardBody,
  BButton,
  BModal,
  BForm,
  BCardText,
  BImg,
  BBadge,
  BCollapse
} from 'bootstrap-vue';
import {
  ValidationProvider,
  ValidationObserver
} from 'vee-validate/dist/vee-validate.full';
import { Vue, Component, Prop } from 'vue-property-decorator';
import ApiClientFactory from '@/api/apiClientFactory';
import { mapActions, mapState } from 'vuex';
import {
  SettingAction,
  SettingState,
  SETTING_STATE_NAMESPACE
} from '@/store/setting/setting.module-types';
import CustomLabel from '@/@core/components/labels/CustomLabel.vue';
import { DropdownOption } from '@/utility/dropdowns/dropdownOptions';
import vSelect from 'vue-select';

@Component({
  components: {
    BCard,
    BCardHeader,
    BCardBody,
    BAvatar,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BRow,
    BCol,
    BDropdown,
    BDropdownItem,
    BButton,
    BModal,
    BForm,
    BCardText,
    BImg,
    BBadge,
    ValidationProvider,
    ValidationObserver,
    CustomLabel,
    vSelect,
    BCollapse
  },
  computed: mapState(SETTING_STATE_NAMESPACE, [SettingState.masterData]),
  methods: mapActions(SETTING_STATE_NAMESPACE, [SettingAction.fetchMasterData])
})
export default class InkjetAddPriceModel extends Vue {
  @Prop({ required: true })
  areas!: number[];

  masterData!: MasterDataViewModel;

  quantityItems: Array<{
    area: number;
    price: number;
  }> = [];

  products: Array<{
    id: number;
    name: string;
  }> = [];

  selectedProduct: any = {};
  processingModels: any[] = [];

  get productOptions(): DropdownOption[] {
    const result: DropdownOption[] = [];
    this.products.map((s) => result.push({ text: s.name ?? '', value: s.id }));

    return result;
  }

  $refs!: {
    formRules: InstanceType<typeof ValidationProvider>;
    modal: InstanceType<typeof BModal>;
  };

  fetchInkjetProductsUnPricing() {
    const client = new ApiClientFactory().priceClient();

    client.getUnpricingProducts().then((result) => {
      this.products = result.map((s) => {
        return {
          id: s.id,
          name: s.name ?? ''
        };
      });
    });
  }

  loadProcessingTypes(productId) {
    const client = new ApiClientFactory().productClient();
    client
      .getProcessingTypes(productId)
      .then((result) => {
        if (result) {
          this.processingModels = [];
          this.processingModels = result.map((s) => {
            return {
              id: s.id,
              name: s.name,
              items: s.processingTypeItemModels?.map((p) => {
                return { id: p.id, name: p.name };
              }),
              edittingValue: '',
              edittingItem: ''
            };
          });
        } else {
          // show toast
          this.$bvToast.toast('Tải gia công thất bại', {
            title: 'Cài đặt gia công',
            toaster: 'b-toaster-bottom-right',
            variant: 'danger'
          });
        }
      })
      .catch((ex) => {
        // show toast
        this.$bvToast.toast(ex.message, {
          title: 'Cài đặt gia công',
          toaster: 'b-toaster-bottom-right',
          variant: 'danger'
        });
      });
  }

  openModal(): void {
    //this.input = this.getDefaultInputValue();
    this.quantityItems = this.areas.map((s) => {
      return {
        area: s,
        price: 0
      };
    });
    this.fetchInkjetProductsUnPricing();
    this.$refs.modal.show();
  }

  closeModal() {
    this.$emit('onClose');
    this.$refs.modal.hide();
  }

  onProductChange() {
    this.loadProcessingTypes(this.selectedProduct.value);
  }

  changeProcessingPrice(value, processingItemId) {
    console.log(processingItemId, value);
  }

  sortAreas(areas: any[]) {
    return [...areas].sort((a, b) => Math.abs(a.area) - Math.abs(b.area));
  }

  formatArea(area: number) {
    if (area < 0) return `Dưới ${Math.abs(area)}m2`;
    return `Trên ${area}m2`;
  }

  submit(): void {
    const client = new ApiClientFactory().priceClient();
    const priceItems = this.quantityItems.map((s) => {
      return {
        minQuantity: 0,
        maxQuantity: 0,
        price: s.price,
        width: s.area,
        height: s.area,
        type: QuotationType.InkjetPrinting
      } as PriceValueInput;
    });
    client
      .addPrice({
        priceValueInputs: priceItems,
        isPricingByQuantity: true,
        productId: parseInt(this.selectedProduct.value),
        name: this.selectedProduct.text
      } as AddPriceInput)
      .then(
        (result) => {
          if (result) {
            // show toast
            this.$bvToast.toast('Thêm giá thành công', {
              title: 'Thêm giá sản phẩm',
              toaster: 'b-toaster-bottom-right',
              variant: 'success'
            });
            this.closeModal();
            return;
          }
          this.$bvToast.toast('Thêm giá thất bại', {
            title: 'Thêm giá sản phẩm',
            toaster: 'b-toaster-bottom-right',
            variant: 'danger'
          });
        },
        (err) => {
          this.$bvToast.toast('Thêm giá thất bại', {
            title: 'Thêm giá sản phẩm',
            toaster: 'b-toaster-bottom-right',
            variant: 'danger'
          });
          console.log(err);
        }
      );
  }
}
